<template>
  <span>
    <el-button size="small margin-left-sm text-olive" type="text" @click="getHistory"
      >查看打印历史</el-button
    >

    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      class="dialog"
      append-to-body
      top="30px"
      width="800px"
      @close="show = false"
    >
      <div class="text-olive text-bold margin-bottom-sm text-lg">模板打印历史</div>
      <div class="flex padding-top solid-top">
        <div class="flex-sub padding-left-xs">
          <vxe-table
            :data="list"
            border
            size="mini"
            :loading="loading"
            :height="this.$root.tableHeight - 200"
          >
            <vxe-column
              fixed="left"
              width="60"
              type="seq"
              title="序号"
              align="center"
            ></vxe-column>
            <vxe-column title="模板标题" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.sysPrintName }}</span>
              </template>
            </vxe-column>
            <vxe-column title="模板类型" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.sysPrintType }}</span>
              </template>
            </vxe-column>
            <vxe-column title="打印时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.sysPrintDate }}</span>
              </template>
            </vxe-column>
            <vxe-column title="操作" align="center" width="100">
              <template slot-scope="scope">
                <span class="text-olive pointer" @click="detailsGo(scope.row)">预览</span
                ><br />
                <!-- <span class="text-olive pointer" @click="detailsTo(scope.row)">打印最新数据</span> -->
              </template>
            </vxe-column>
          </vxe-table>
          <div>
            <pagination
              :total="listQuery.total"
              :page.sync="listQuery.pageNum"
              :limit.sync="listQuery.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              style="text-align: right; float: right"
              @pagination="getHistory"
            />
          </div>
        </div>
        <print-preview
          :title="title"
          ref="preView"
          :modules="modules"
          :printModule="printModule"
        />
      </div>
    </el-dialog>
  </span>
</template>
<script>
import { sysPrintHistoryContent_list, sysPrint_view } from '@/api/myController/system';
import printPreview from '@/views/supplier/preview';
import { generateRandomString } from '@/utils';
import { modulesList, processModules } from './printModules';
export default {
  components: { printPreview },
  props: {
    // 打印接口参数
    modules: {
      type: Number,
      required: false,
      default: 0
    },
    printModule: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    },
    printFun: {
      type: Function,
      required: false,
      default: null
    }
  },
  data() {
    return {
      title: '打印历史预览',
      modulesList,
      show: false,
      list: [],
      showDetail: false,
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      loading: false,
      width: 0,
      randomString: ''
    };
  },
  mounted() {
    this.randomString = generateRandomString();
    console.log(this.printModule);
    var pdata = JSON.parse(this.printModule.printTemplateDetails ?? '{}');
    this.width = pdata.panels ? pdata.panels[0].width : 210;
    console.log(this.printModule, this.width);
  },
  methods: {
    getHistory() {
      this.loading = true;
      if (!this.printModule?.modules) {
        this.$message.warning('未选择打印模板');
        return;
      }
      sysPrintHistoryContent_list({
        sysPrintHistoryContentDtoFilter: this.printModule,
        pageParam: this.listQuery
      }).then((res) => {
        this.loading = false;
        this.list = res.data.data.dataList;
        this.listQuery.total = res.data.data.totalCount;
        this.show = true;
      });
    },
    detailsTo(e) {
      this.title = '打印最新数据';
      sysPrint_view({ sysPrintId: e.sysPrintId }).then((res) => {
        var hiprintTemplate = new hiprint.PrintTemplate({
          template: JSON.parse(res.data.data.printTemplateDetails)
        });
        var printData = JSON.parse(e.printContentDetails);
        processModules(this, printData, this.modules, this.printFun).then((res) => {
          this.$refs.preView.show(hiprintTemplate, res);
        });
      });
    },
    detailsGo(e) {
      this.title = '打印历史预览';
      console.log('--------------1', this.printModule);
      console.log('--------------2', this.modules);
      this.$refs.preView.showHt(e.printContentDetails, e.other1, e.other2);
      // sysPrint_view({ sysPrintId: e.sysPrintId }).then(res => {
      //     var hiprintTemplate = new hiprint.PrintTemplate({
      //         template: JSON.parse(res.data.data.printTemplateDetails),
      //     });
      //     var printData = JSON.parse(e.printContentDetails);
      //     setTimeout(() => {
      //         this.$refs.preView.show(hiprintTemplate, printData);
      //     }, 100);
      // })
    }
  }
};
</script>
